import styled from '@emotion/styled'
import { Site } from '@pubstack/common/src/site'
import { FunctionComponent } from 'react'
import { useUpdateSite } from '~/api/app/sites.api'
import { useAuthenticatedUser } from '~/auth/user.hooks'
import Button from '~/components/Button'
import { useGlobalModal } from '~/components/layout/GlobalModal'
import { Modal } from '~/components/Modal'

const Paragraphs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  & > * {
    display: inline-flex;
    flex-direction: column;
  }
`

export const SettingsSitesArchiveSiteModal: FunctionComponent<{ site: Site }> = ({ site }) => {
  const user = useAuthenticatedUser()
  const { close } = useGlobalModal()
  const { mutateAsync: archiveSite } = useUpdateSite(user.currentScopeId, site.id, {
    successToast: (
      <>
        <strong>{site.name}</strong> was successfully archived.
      </>
    ),
    errorToast: (
      <>
        An error occurred while trying to archive <strong>{site.name}</strong>.
      </>
    ),
  })
  return (
    <Modal.Content>
      <Modal.Title>Archive site</Modal.Title>
      <Modal.Body>
        <Paragraphs>
          <p>
            <span>
              You are about to archive <strong>{site.name}</strong>
            </span>
            <span>You won’t be able to view its data in Pubstack anymore.</span>
          </p>
          <p>Do you confirm your choice ?</p>
        </Paragraphs>
      </Modal.Body>
      <Modal.Actions>
        <Button onClick={close} variant={'tertiary'} trackingLabel={'common-settings-site-archive-cancel'}>
          Cancel
        </Button>
        <Button
          iconName={'archive'}
          onClick={async () => {
            await archiveSite({ ...site, enabled: false })
            close()
          }}
          variant={'negative'}
          trackingLabel={'common-settings-site-archive-confirm'}
        >
          Archive site
        </Button>
      </Modal.Actions>
    </Modal.Content>
  )
}
